export default {
  blog: {
    seo: {
      title: 'Blog',
      description:
        'Articles pratiques sur la livraison du dernier kilomètre, la gestion de flotte, l\'expérience client et comment les équipes utilisent Geofleet pour des opérations plus intelligentes.',
    },
    badge: 'Blog',
    hero: {
      title: 'Des idées pour des',
      titleHighlight: 'opérations de livraison plus intelligentes',
      description:
        'Articles pratiques sur la livraison du dernier kilomètre, la gestion de flotte, l\'expérience client et comment les équipes utilisent Geofleet.',
    },
    filters: {
      categoryLabel: 'Catégorie',
      allCategories: 'Toutes les catégories',
      searchLabel: 'Rechercher des articles par titre',
      searchPlaceholder: 'Rechercher des articles...',
      all: 'Tout',
    },
    featured: {
      label: 'Article à la une',
      readCta: 'Lire l\'article',
    },
    list: {
      latestTitle: 'Derniers articles',
      title: 'Articles',
      showingInCategory: '{{count}} article dans {{category}}',
      showingInCategory_other: '{{count}} articles dans {{category}}',
      defaultSubtitle: 'Nouvelles perspectives sur la livraison, le dispatch et les opérations de flotte',
      article_one: '{{count}} article',
      article_other: '{{count}} articles',
    },
    empty: {
      title: 'Aucun article ne correspond à votre recherche',
      hint: 'Essayez d\'autres mots-clés ou choisissez une autre catégorie.',
    },
    card: {
      readMore: 'Lire la suite',
    },
    pagination: {
      previous: 'Précédent',
      next: 'Suivant',
      pageOf: 'Page {{current}} sur {{total}}',
    },
    cta: {
      title: 'Prêt à améliorer vos opérations de livraison ?',
      subtitle: 'Commencez en quelques minutes. Plans dès 100 $ par mois pour 10 chauffeurs.',
    },
    post: {
      ogImageAlt: '{{title}} — Blog Geofleet',
      backToBlog: 'Retour au blog',
      updatedOn: 'Mis à jour le {{date}}',
      publishedOn: 'Publié le {{date}}',
      disclosure: 'Transparence : ce comparatif est publié par Geofleet et nous plaçons notre produit en premier. Chaque autre produit est décrit à partir des pages produit et tarifs publiques de son éditeur, avec un « idéal pour » équitable.',
      pitch: {
        eyebrow: 'Essayez notre n°1',
        title: 'Geofleet : à partir de 100 $ par mois pour 10 chauffeurs',
        text: 'Commencez avec Geofleet Lite à 100 $ par mois pour 10 chauffeurs et 2 000 commandes : planification des tournées, suivi en direct, liens de suivi client, preuve de livraison et paiement à la livraison pour un seul hub. Les équipes multi-hubs passent à Professional dès 19 $ par chauffeur et par mois, avec suivi personnalisé et agents IA sur les plans supérieurs.',
        startFree: 'Commencer',
        bookDemo: 'Réserver une démo',
        caseStudy: 'Lire l’étude de cas',
      },
      keyTakeaways: 'Points clés',
      tocAriaLabel: 'Table des matières',
      tocTitle: 'Sommaire',
      relatedTitle: 'Articles connexes',
      cta: {
        title: 'Découvrez le centre de commande Geofleet',
        subtitle: 'Voyez comment les agents IA peuvent optimiser vos opérations. Commencez dès maintenant ou réservez une démo avec notre équipe.',
        bookDemo: 'Réserver une démo Geofleet',
        aiAgentsLink: 'Agents IA dans Geofleet',
      },
    },
  },
};
